import clsx from 'clsx';
import React from 'react';

interface SportIconProps {
    sportId?: string | number;
    sizeX?: string | number;
    sizeY?: string | number;
    dataAtid?: string;
    title?: string;
    viewBox?: string;
    isFilled?: boolean;
    className?: string;
}

export const SportIconNui = ({
    sportId,
    sizeX = '20px',
    sizeY = '20px',
    dataAtid,
    title,
    viewBox,
    isFilled = true,
    className
}: SportIconProps) => {
    const preFix = 's';
    const postFix = '-sl';
    const symbol = sportId ? document.querySelector(`symbol#${preFix}${sportId}${postFix}`) : false;
    const symbolId = symbol ? `#${preFix}${sportId}${postFix}` : 'default';
    return (
        <svg
            width={sizeX}
            height={sizeY}
            className={clsx(isFilled ? `fill-${sportId}` : '', className, { 'c-orange': !symbol })}
            data-atid={dataAtid}
            viewBox={viewBox}
        >
            {title && <title>{title}</title>}
            <use xlinkHref={symbolId} width={sizeX} height={sizeY} style={{ pointerEvents: 'none' }} />
        </svg>
    );
};
